import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const MNH_PRATIQUE_ROUTES = CONF?.ROUTES?.MNH_PRATIQUE

export const getMnhPratique = async () => {

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.get(MNH_PRATIQUE_ROUTES?.GET_PAGES_REFERENCES)
        const rows = resp?.data?.rows

        if (rows?.length > 0) {

            return rows
        } else {

            throw new Error("Aucune base documentaire trouvée")
        }

    } catch (err) {
        throw err;
    }
}

export const getCategoriesWithDocumentsWithIdf = async (pageIdf) => {

    const urlWithId = replaceUrlPlaceholders(MNH_PRATIQUE_ROUTES?.GET_CATEGORIES_WITH_DOCUMENTS_WITH_IDF, { pageIdf: pageIdf })

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.get(urlWithId)
        const rows = resp?.data?.rows

        if (rows?.length > 0) {

            return rows
        } else {

            throw new Error("Aucune base documentaire trouvée")
        }
    } catch (err) {
        throw err;
    }
}

export const updateCategoriesWithDocuments = async (dataToSend, pageIdf) => {

    console.log("dataToSend")
    console.log(dataToSend)
    console.log("pageIdf")
    console.log(pageIdf)

    const urlWithId = replaceUrlPlaceholders(MNH_PRATIQUE_ROUTES?.UPDATE_CATEGORIES_WITH_DOCUMENTS, { pageIdf: pageIdf })

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.put(urlWithId, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const addCategorie = async (dataToSend, pageIdf) => {

    const urlWithId = replaceUrlPlaceholders(MNH_PRATIQUE_ROUTES?.ADD_CATEGORIE, { pageIdf: pageIdf })

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.post(urlWithId, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const deleteCategorie = async (idCategorie, pageIdf) => {

    const urlWithId = replaceUrlPlaceholders(MNH_PRATIQUE_ROUTES?.DELETE_CATEGORIE, {
        id: idCategorie,
        pageIdf: pageIdf
    })

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.delete(urlWithId, { data: { idCategorie: idCategorie, pageIdf: pageIdf } })
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const addDocument = async (dataToSend, pageIdf) => {

    const urlWithId = replaceUrlPlaceholders(MNH_PRATIQUE_ROUTES?.ADD_DOCUMENT, { pageIdf: pageIdf })

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.post(urlWithId, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const deleteDocument = async (idDoc, idCategorie, pageIdf) => {

    const urlWithId = replaceUrlPlaceholders(MNH_PRATIQUE_ROUTES?.DELETE_DOCUMENT, { id: idDoc, pageIdf: pageIdf })

    // eslint-disable-next-line no-useless-catch
    try {
        const resp = await axiosCoralie.delete(urlWithId, { data: { idDoc: idDoc, idCategorie: idCategorie } })
        return resp?.data

    } catch (err) {

        throw err;
    }
}